<template>
  <div class="browse-vehicles-background-component" role="region">
    <div class="background-row" :style="{backgroundImage: bgPhoto}"></div>
    <div class="background-image-overlay">
      <div class="overlay-content">
        <video v-if="images.videoLink.length > 0"
          autoplay="true"
          class="hidden-xs"
          id="homepage-background-video"
          loop="true"
          muted="true"
        >
          <source
            class="ajax-video"
            :src="images.videoLink"
            type="video/mp4"
          />
        </video>
        <div class="browse-vechicles">
          <div class="container vehicle-browse-ajax">
            <div class="browse-step" id="first-step">
              <h2 class="text-center step-instructions"></h2>
              <div class="row">
                <div class="col-md-3 col-sm-6 col-xs-6" v-for="button in images.roundButtons" :key="button.index">
                  <a href="#" data-category="Home Page Actions">
                    <img class="img-responsive center-block" :src="button" alt="Shop">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    },
    bgPhoto () {
      if (this.brand !== 'honda' && this.brand !== 'cjdr') {
        return 'url(' + this.images.lifestyleImages.defaultImage + ')';
      } else if (this.brand === 'cjdr') {
        return 'url(' + this.images.lifestyleImages.truckImage + ')';
      } else {
        return 'url(' + this.images.lifestyleImages.suvImage + ')';
      }
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.browse-vehicles-background-component .browse-step .img-responsive {
  margin: auto;
}
.browse-vehicles-background-component {
  position: relative;
  overflow: hidden;
}
.browse-vehicles-background-component .background-row {
  position: absolute;
  z-index: -1;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  overflow: hidden;
  background-size: cover;
  background-color: #222;
  background-repeat: no-repeat;
  background-position: 50% 50%;
}
.browse-vehicles-background-component .background-image-overlay {
  display: table;
  width: 100%;
  text-align: center;
  height: 100%;
}
.browse-vehicles-background-component .background-image-overlay .overlay-content {
  display: table-cell;
  max-width: 1200px;
  padding: 8% 0 10%;
}
.browse-vehicles-background-component .background-image-overlay .overlay-content .browse-vechicles {
  background: transparent;
}
.browse-vehicles-background-component .background-image-overlay .overlay-content .browse-vechicles .vehicle-browse-ajax {
  padding: 15px;
}
.browse-vehicles-background-component .background-image-overlay .overlay-content .browse-vechicles .vehicle-browse-ajax img {
  margin-bottom: 30px;
  opacity: .9;
  transition: all .3s ease;
}
.browse-vehicles-background-component .background-image-overlay .overlay-content .browse-vechicles .vehicle-browse-ajax img:hover {
    opacity: 1;
    filter: brightness(1.2);
  }
.browse-vehicles-background-component .background-image-overlay .overlay-content .browse-vechicles .step-instructions {
  color: #fff;
}
.browse-vehicles-background-component .background-image-overlay .overlay-content video#homepage-background-video {
  position: absolute;
  top: -30%;
  left: 0;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1;
  background-size: cover;
}

@media (max-width: 1199px) {
  .browse-vehicles-background-component {
    height: auto;
    max-height: none;
    min-height: unset;
  }
  .browse-vehicles-background-component .background-image-overlay .overlay-content .browse-vechicles .vehicle-browse-ajax img {
    max-width: 250px;
    width: 100%;
  }
}
</style>
